import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { useCallsDialogContext } from '@src/app/voice/context/useCallsDialogContext'
import type AddParticipantController from '@src/app/voice/store/AddParticipantController'
import type CallTransferController from '@src/app/voice/store/CallTransferController'
import TextInput from '@ui/TextInput'
import Typography from '@ui/Typography'

import * as styles from './MessageTextInput.css'

interface MessageTextInputProps {
  controller: AddParticipantController | CallTransferController
}

const MessageTextInput = ({ controller }: MessageTextInputProps) => {
  const { blurred } = useCallsDialogContext()

  return (
    <div className={cx(styles.root, { [styles.rootBlurred]: blurred })}>
      <TextInput
        className={styles.textArea}
        ref={controller.messageRef}
        placeholder="Add a short message…"
        data-allow-keyboard-when-empty
        variant="outlined"
        size={35}
        hasError={controller.maxMessageLengthReached}
        value={controller.message}
        onChange={controller.handleMessageChange}
        onFocus={controller.handleMessageFocus}
        onBlur={controller.handleMessageBlur}
      />
      {controller.maxMessageLengthReached ? (
        <Typography variant="caption1" className={styles.caption}>
          Invite message too long
        </Typography>
      ) : null}
    </div>
  )
}

export default observer(MessageTextInput)
